import React, { useState, useEffect,  } from 'react';

import { Dialog, Card, Collapse } from '@mui/material';
import { images, icons, markers } from "../../helpers/constants";
import { Trans, useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import SafetyZoneMap from '../Map/SafetyZoneMap';
import { downloadPDF, fixDate } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import NewButton from '../Buttons/NewButton';


const ExportDataModal = ({show, onClose, info, device, type, onSave, download}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [centralName, setCentralName] = useState()
    const [errorText, setErrorText] = useState()
    const [openStart, setOpenStart] = useState(false)
    const [openEnd, setOpenEnd] = useState(false)

    const [startDate, setStartDate] = useState(dayjs().subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs())


    const [selectedType, setSelectedType] = useState(-1)
    const [selectedFormat, setSelectedFormat] = useState(null)

    const handleClose = () => {
        onClose()
        setTimeout(() => {
            setSelectedType(-1)

        }, 200);
      //  setShow(false)
    }

    const handleSave = (type) => {        
        if(!selectedFormat){
            toast.error(t("toast.no_format_export"))
            return
        }
        if(!selectedType){
            toast.error(t("toast.no_type_export"))
            return
        }
    
        let data = {}
        let reset = false
        data.deviceid = device?.id
        data.starttime = startDate.toDate()
        data.stoptime = endDate.toDate()
       //data.starttime = "2025-01-07 10:05:20"
       //data.stoptime = "2025-01-11 13:01:58"
        data.format = selectedFormat
        data.type = selectedType

        onSave(data, reset)
    }


    const handleChange = (type, e) => {
        switch(type){
            case "info":
                setCentralName(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }
    
    const minDate = info?.history_limit?.from ? dayjs(info.history_limit.from).startOf("day") : undefined;
    const hasMinDate = !!minDate
    const generateContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                    <h3 className="">{t("settings.export_data")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
                <p className="grey-blue py-3">{t("settings.export_data_sub")}</p>
                <p className="mb-1 bold mt-3">{t("settings.type_of_data")}</p>
                <div className="select-wrap w-100">
                    <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)} className="bg-light-grey grey-blue form-control text-truncate p-3 rounded24">
                        <option value="-1">{t("settings.select")}</option>
                        {Object.entries(info?.types || {})
                            .filter(([_, value]) => value.allowed)
                            .map(([key]) => (
                            <option key={key} value={key}>
                                {t(`settings.${key}`)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={`mt-3 ${selectedType === -1 || selectedType === "-1" ? "d-none" : ""}`}>
                    <p className="mb-1 bold">{t("settings.timespan")}</p>
                    <div className="d-flex justify-content-around m-0 p-0">
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
                            <DateTimePicker
                                open={openStart}
                                onClose={() => setOpenStart(false)}
                                ampm={false}
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                minDateTime={hasMinDate ? minDate : undefined}
                                maxDateTime={endDate}
                                className="date_label me-1 bg-light-grey p-3 rounded24 align-items-center cursor-pointer"
                                format="DD/MM HH:mm" 
                                slotProps={{
                                    openPickerButton: { disableRipple: true },
                                    textField: {
                                        onClick: () => setOpenStart(true),
                                        readOnly: true,
                                        className:
                                            "date_label bg-light-grey p-3 rounded24 align-items-center cursor-pointer",
                                    },
                                }}
                                slots={{ openPickerIcon: () => null }}
                            />
                        </LocalizationProvider>
                        <p className="m-0 p-0 bold align-self-center mx-2">{t("settings.to")}</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
                            <DateTimePicker
                                open={openEnd}
                                onClose={() => setOpenEnd(false)}
                                ampm={false}
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                minDate={startDate}
                                className="date_label ms-1 bg-light-grey p-3 rounded24 align-items-center cursor-pointer"
                                format="DD/MM HH:mm" 
                                slotProps={{
                                    openPickerButton: { disableRipple: true },
                                    textField: {
                                        onClick: () => setOpenEnd(true),
                                        readOnly: true,
                                        className:
                                            "date_label ms-1 bg-light-grey p-3 rounded24 align-items-center cursor-pointer",
                                    },
                                }}
                                slots={{ openPickerIcon: () => null }}
                            />
                        </LocalizationProvider>
                    </div>
                    <p className="mb-1 bold mt-3">{t("settings.select_format")}</p>
                    <div className="select-wrap w-100">
                        <select value={selectedFormat ?? -1} onChange={(e) => setSelectedFormat(e.target.value)} className="bg-light-grey grey-blue form-control text-truncate p-3 rounded24">
                            <option value="-1">{t("settings.select")}</option>
                            {(info?.types?.[selectedType]?.formats || []).map((format) => (
                            <option key={format} value={format}>
                                {format}
                            </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave("")} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.confirm")}</NewButton>
                </div>
            </div>
        )
    }

    const downloadContent = () => {
        const data = type.content
        let icon;
        switch(data.type){
            case "positions":
                icon = icons.sidebar.history_active
                break;
            case "temp_humidity":
                icon = icons.temperature
                break;
            case "battery":
                icon = icons.battery.battery_100
                break;
            case "externalvoltage":
                icon = icons.ignition
                break;
            default: icon = icons.sidebar.history_active
        }
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.download_data")}</h3>
                    </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.download_data_sub")}</p>
                <div className="bg-light-grey rounded24 position-relative p-3">
                    <img src={icon} className="size_25 position-absolute top-0 end-0 mt-2 me-2 grey-blue-icon" alt=""/>
                    <h4 className="m-0 p-0">{t(`settings.${data.type}`)}</h4>
                    <p className="mt-2">{t("settings.from")}: <span className="bold">{fixDate(data?.period?.from, true)}</span></p>
                    <p className="">{t("settings.to")}: <span className="bold">{fixDate(data?.period?.to, true)}</span></p>
                    <p className="">{t("settings.format")}: <span className="bold">{data?.format}</span></p>
                    <p className="mt-2">{t("settings.export_created")}: <span className="bold">{fixDate(data?.created, true)}</span></p>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => download(data.downloadtoken)} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.download")}</NewButton>
                </div>
            </div>
        )
    }



    const typeRender = () => {
        switch (type.type){
            case "generate":
                return generateContent()
            case "download":
                return downloadContent()
            default: return null
        }
        
        
    }


return(
    <>
    <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
        <Card className="settings-dialog d-flex flex-column scrollable-y">
            <div className="w-100 h-100 grey-blue">
                {typeRender()}
            </div>
        </Card>
    </Dialog>
    </>
)
}

export default ExportDataModal;